import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { KeyValue } from "../models/common";
import { IClaimTypeApi } from "./base";

const baseRoute: string = "ClaimType";

export class ClaimTypeApi extends IClaimTypeApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
